<!--
@component  Combination of several control elements returning a single JSON with parameters.
-->
<script>
   import Container from "./Container.svelte";
   let {
      title = '',
      options,               // array with all options (see details)
      value = $bindable(),   // JSON with properties
      labelWidth = 13,
   } = $props();

   function getDefaults(options) {
      const out = {};
      for(const opt of Object.keys(options)) {
         out[opt] = options[opt].default;
      }
      return out;
   }

   $effect(() => {
      if (!value && options) value = getDefaults(options);
   });
</script>

<div class="widget" >
   {#if value}

      {#if title}
      <Container>
         <h2>{title}</h2>
      </Container>
      {/if}

      {#each Object.keys(options) as id}
         {@const opt = options[id]}
         {#if !opt.hidden}
         <Container name={opt.name} label={opt.label} {labelWidth}>
         <opt.el {...opt.props} bind:value={value[id]}/>
         </Container>
         {/if}
      {/each}
   {/if}
</div>